import { WithChildren } from '@config';
import { createContext, SetStateAction, useState } from 'react';

type LayoutProviderType = {
  shouldRefreshLessonLearnt: boolean;
  setRefreshLessonLearnt: (value: SetStateAction<boolean>) => void;
  eddrData: {
    date: string;
    tuwi: string;
    isLessonLearnt?: boolean;
  };
  setEddrData: (
    value: SetStateAction<{
      date: string;
      tuwi: string;
      isLessonLearnt?: boolean;
    }>,
  ) => void;
};

const defaultState = {
  shouldRefreshLessonLearnt: false,
  setRefreshLessonLearnt: () => undefined,
  eddrData: {
    date: '',
    tuwi: '',
    isLessonLearnt: false,
  },
  setEddrData: () => undefined,
} as LayoutProviderType;

export const LayoutContext = createContext(defaultState);

export const LayoutProvider = ({ children }: WithChildren) => {
  const [shouldRefreshLessonLearnt, setRefreshLessonLearnt] = useState<boolean>(false);
  const [eddrData, setEddrData] = useState<{
    date: string;
    tuwi: string;
    isLessonLearnt?: boolean;
  }>({
    date: '',
    tuwi: '',
    isLessonLearnt: false,
  });

  return (
    <LayoutContext.Provider
      value={{ shouldRefreshLessonLearnt, setRefreshLessonLearnt, eddrData, setEddrData }}
    >
      {children}
    </LayoutContext.Provider>
  );
};
